import {IServicePerformanceState} from '../state'
import {chain} from 'lodash'
import {IUpdateServicesFilterSuccessActionInt} from '../actions/load-services-int'
import {getfilteredData} from '../methods/load-filter-data-int'
import {AsyncActionState} from '@telstra-connect/standard-actions/async-action'
import {
  IServicesListByServiceIdIntResponse,
  IServicesListByServiceTypeIntResponse,
  IServicesListBySiteAddressIntResponse,
} from '../state/services-list-filter-int'
import {initialState} from '../state/initial-state'
import {getServicePerformanceFlagName} from '@applications/index'
import {ServiceFamiliesFlags} from '@applications/utility-methods'

export const updateServicesSuccessGroupByReducer = (
  state: IServicePerformanceState,
  action: IUpdateServicesFilterSuccessActionInt,
) => {
  const updatedServicesFilters = (action as IUpdateServicesFilterSuccessActionInt).data.services
    .searchString
  const updatedUserType = (action as IUpdateServicesFilterSuccessActionInt).data.services.userType
  const companies = (action as IUpdateServicesFilterSuccessActionInt).data.companies
  const locations = (action as IUpdateServicesFilterSuccessActionInt).data.locations || []
  const serviceTypes = (action as IUpdateServicesFilterSuccessActionInt).data.serviceTypes || []
  const isReset = (action as IUpdateServicesFilterSuccessActionInt).data.isReset || false
  const groupBy = (action as IUpdateServicesFilterSuccessActionInt).data.groupBy || ''
  const category = (action as IUpdateServicesFilterSuccessActionInt).data.category || ''

  const eligibleServiceTypes: string[] =
    (getServicePerformanceFlagName(ServiceFamiliesFlags[category]) as string[]) || []
  const originalData = {...state.servicesInt.data}
  originalData.originalServices = [
    ...state.servicesInt.data.originalServices.filter((item) =>
      eligibleServiceTypes.some((ele) => item.serviceType.toLowerCase() === ele.toLowerCase()),
    ),
  ]
  originalData.filterInt.services.searchString =
    updatedServicesFilters !== undefined
      ? updatedServicesFilters
      : state.servicesInt.data.filterInt.services.searchString
  originalData.filterInt.services.userType =
    updatedUserType !== undefined
      ? updatedUserType
      : state.servicesInt.data.filterInt.services.userType
  const filteredServices = getfilteredData(originalData, companies, {
    locations,
    serviceTypes,
  })
  const filteredServiceSite = chain(filteredServices)
    .map((item) => item.aEnd.slice(0, 80))
    .uniq()
    .value()
  let adaptiveNetworkServiceTypes = chain(originalData.originalServices)
    .map((item) => item.serviceType.toUpperCase())
    .uniq()
    .value()
  adaptiveNetworkServiceTypes = adaptiveNetworkServiceTypes.filter((ele) => ele !== '')
  let adaptiveNetworkCountries = chain(originalData.originalServices)
    .map((item) => item.country.toUpperCase())
    .uniq()
    .value()
  adaptiveNetworkCountries = adaptiveNetworkCountries.filter((ele) => ele !== '')
  let groupByFilteredData
  if (groupBy == 'bySiteAddress') {
    groupByFilteredData = chain(filteredServices)
      .orderBy('company', 'asc')
      .orderBy('aEnd', 'asc')
      .groupBy('aEnd')
      .map((servicesData, aEnd) => {
        const siteAddress = aEnd
        const numberOfServices = servicesData.length
        const company = servicesData[0].accountName
        const country = servicesData[0].country
        const location = servicesData[0].location
        const services = servicesData
        return ({
          siteAddress,
          numberOfServices,
          company,
          country,
          services,
          location,
        } as unknown) as IServicesListBySiteAddressIntResponse
      })
      .value()
  }
  if (groupBy == 'byServiceType') {
    groupByFilteredData = chain(filteredServices)
      .orderBy('company', 'asc')
      .orderBy('serviceType', 'asc')
      .groupBy(({serviceType, accountName}) => `${serviceType}|${accountName}`)
      .map((servicesData, key) => {
        const servicesType = servicesData[0].serviceType
        const numberOfServices = servicesData.length
        const company = servicesData[0].accountName
        const services = servicesData
        return ({
          servicesType,
          numberOfServices,
          company,
          services,
        } as unknown) as IServicesListByServiceTypeIntResponse
      })
      .value()
  }
  if (groupBy == 'byServiceId') {
    groupByFilteredData = chain(filteredServices)
      .orderBy('company', 'asc')
      .orderBy('serviceId', 'asc')
      .orderBy('serviceType', 'asc')
      .value()
    groupByFilteredData = (groupByFilteredData as unknown) as IServicesListByServiceIdIntResponse
  }
  return {
    ...state,
    servicesListFilterInt: {
      ...initialState.servicesListFilterInt,
      status: isReset ? AsyncActionState.Initiated : AsyncActionState.Success,
      data: {
        services: groupByFilteredData,
        filteredSites: filteredServiceSite,
        adaptiveNetworkCountries,
        adaptiveNetworkServiceTypes,
      },
    },
  }
}
